var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBigMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 61
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-14 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h71v71H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545AA3",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M35.5 6C24.166 6 15 15.077 15 26.3 15 41.525 35.5 64 35.5 64S56 41.525 56 26.3C56 15.077 46.834 6 35.5 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 26.5,
    r: 8.5,
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF"
  }))));
}

export default SvgBigMarker;